/**
 * Deeply compares as nested object returning only those
 * which have a given key which matches one of the values in the given array
 * @param {array} options,
 * @param {array} preSelectedIds,
 * @param {array} preSelectedNames,
 * @param {bool} preSelectFirstOption,
 * @param {array} selectedOptions
 */
export const reduceOptionsBy = (items, array, key) => items.reduce((acc, item) => {
  if (item.child) {
    const options = reduceOptionsBy(item.child, array, key)[0];
    if (options) acc.push(options);
  }

  const matchedItem = array.reduce((matchedItems, value) => {
    if (item[key] === value) matchedItems.push(item);
    return matchedItems;
  }, [])[0];

  if (matchedItem) acc.push(matchedItem);

  return acc;
}, []);

/**
 * Returns initial selection of defined preselected items based on options.
 * @param {array} options,
 * @param {array} preSelectedIds,
 * @param {array} preSelectedNames,
 * @param {bool} preSelectFirstOption,
 * @param {array} selectedOptions
 */
export const getPreSelected = ({
  options,
  preSelectedIds,
  preSelectedNames,
  preSelectFirstOption
}) => {
  if (preSelectFirstOption) {
    return [options[0]];
  }
  if (preSelectedIds) {
    return reduceOptionsBy(options, preSelectedIds, 'id');
  }
  if (preSelectedNames) {
    return reduceOptionsBy(options, preSelectedNames, 'name');
  }
  return [];
};

/**
 * Retrieve full list objects when only id is provided on form value.
 *
 * @param {array} value The value prop on the Dropdown field
 * @param {array} options The full list of options
 *
 * @returns {array} [selectedOptions, isMutated]
 *  First value is the full object list. Second value indicates if data was mutated or not.
 */
export const getPreSelectedFormData = (value, options) => {
  // Check first value for 'name' property.
  // If it doesn't exist, we need to retrieve the full object
  if (value && value[0] && value[0].id && !value[0].name) {
    const preSelectedIds = value.map(val => val.id);
    return [reduceOptionsBy(options, preSelectedIds, 'id'), true];
  }

  return [value, false];
};
